export default function ComparisonTable() {
  const rows = [
    { feature: "Automation", gtbuy: "Advanced", kakobuy: "Medium", superbuy: "Medium" },
    { feature: "Speed", gtbuy: "Fast", kakobuy: "Medium", superbuy: "Medium" },
    { feature: "Data Sync", gtbuy: "Real-time", kakobuy: "Partial", superbuy: "Partial" },
    { feature: "Scalability", gtbuy: "High", kakobuy: "Medium", superbuy: "Medium" },
  ];

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 text-center mb-3">
          Feature Comparison
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          See how GTBuy Spreadsheet stacks up against other spreadsheet solutions
        </p>

        <div className="overflow-x-auto rounded-lg border border-background-200/70">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-background-200/70 bg-background-100">
                <th className="px-6 py-4 text-sm font-medium text-foreground-700">Feature</th>
                <th className="px-6 py-4 text-sm font-bold text-primary-500">
                  GTBuy Spreadsheet
                </th>
                <th className="px-6 py-4 text-sm font-medium text-foreground-600">
                  Kakobuy Spreadsheet
                </th>
                <th className="px-6 py-4 text-sm font-medium text-foreground-600">
                  Superbuy Spreadsheet
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr
                  key={row.feature}
                  className={`border-b border-background-200/50 ${
                    i % 2 === 0 ? "bg-background-50" : "bg-background-100/50"
                  } hover:bg-primary-50/30 transition-colors`}
                >
                  <td className="px-6 py-3.5 text-sm text-foreground-700 font-medium">
                    {row.feature}
                  </td>
                  <td className="px-6 py-3.5 text-sm font-semibold text-primary-600">
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-check-line text-accent-500"></i>
                      {row.gtbuy}
                    </span>
                  </td>
                  <td className="px-6 py-3.5 text-sm text-foreground-600">{row.kakobuy}</td>
                  <td className="px-6 py-3.5 text-sm text-foreground-600">{row.superbuy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}